import { useSelector } from 'react-redux'
import { selectUserType } from '@/features/domain/user'

export function useCanShowVoice() {
  const userRole = useSelector(selectUserType)
  return userRole === 'admin'
}
